module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EV7IpQ/tc-custom/9780226519180.jpg?1724851494528",
      "alt": "This image is the cover for the book Liberalism and Empire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Liberalism and Empire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("We take liberalism to be a set of ideas committed to political rights and self-determination, yet it also served to justify an empire built on political domination. Uday Mehta argues that imperialism, far from contradicting liberal tenets, in fact stemmed from liberal assumptions about reason and historical progress. Confronted with unfamiliar cultures such as India, British liberals could only see them as backward or infantile. In this, liberals manifested a narrow conception of human experience and ways of being in the world."), _c('br'), _c('br'), _vm._v(" Ironically, it is in the conservative Edmund Burke—a severe critic of Britain's arrogant, paternalistic colonial expansion—that Mehta finds an alternative and more capacious liberal vision. Shedding light on a fundamental tension in liberal theory, "), _c('i', [_vm._v("Liberalism and Empire")]), _vm._v(" reaches beyond post-colonial studies to revise our conception of the grand liberal tradition and the conception of experience with which it is associated."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Uday Singh Mehta\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Please fill in author biography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0